import {
  rtkApi,
  GET_TEACHER_ATTENDANCE,
  GET_TEACHER_ATTENDANCE_HISTORY,
  GET_TEACHER_MODULE_ATTENDANCE,
  GET_TEACHER_LESSON_DETAILS,
} from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import {
  ITeacherAttendanceRequest,
  ITeacherAttendanceResponse,
  ICreateBulkAttendanceRequest,
  ICreateBulkAttendanceResponse,
  IUpdateAttendanceRequest,
  IUpdateAttendanceResponse,
  ITeacherAttendanceHistoryRequest,
  ITeacherAttendanceHistoryResponse,
  ITeacherModuleAttendanceRequest,
  ITeacherModuleAttendanceResponse,
} from './types';

const teacherAttendanceApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    // GET /teacher/groupLessons/{groupLessonId}/attendance
    getTeacherAttendance: build.query<ITeacherAttendanceResponse, ITeacherAttendanceRequest>({
      query: ({ groupLessonId }) => `/teacher/groupLessons/${groupLessonId}/attendance`,
      transformResponse: (response: SuccessApiResponse<ITeacherAttendanceResponse>) =>
        response.data,
      providesTags: [GET_TEACHER_ATTENDANCE],
    }),

    // POST /teacher/groupLessons/{groupLessonId}/attendance
    createBulkAttendance: build.mutation<
      ICreateBulkAttendanceResponse,
      ICreateBulkAttendanceRequest
    >({
      query: ({ groupLessonId, students }) => ({
        url: `/teacher/groupLessons/${groupLessonId}/attendance`,
        method: 'POST',
        body: { students },
      }),
      transformResponse: (response: SuccessApiResponse<ICreateBulkAttendanceResponse>) =>
        response.data,
      invalidatesTags: [
        GET_TEACHER_ATTENDANCE,
        GET_TEACHER_MODULE_ATTENDANCE,
        GET_TEACHER_LESSON_DETAILS,
      ],
    }),

    // PUT /teacher/groupLessons/{groupLessonId}/attendance/{enrollmentId}
    updateAttendance: build.mutation<IUpdateAttendanceResponse, IUpdateAttendanceRequest>({
      query: ({ groupLessonId, enrollmentId, value, comment }) => ({
        url: `/teacher/groupLessons/${groupLessonId}/attendance/${enrollmentId}`,
        method: 'PUT',
        body: { value, comment },
      }),
      transformResponse: (response: SuccessApiResponse<IUpdateAttendanceResponse>) => response.data,
      invalidatesTags: [
        GET_TEACHER_ATTENDANCE,
        GET_TEACHER_ATTENDANCE_HISTORY,
        GET_TEACHER_MODULE_ATTENDANCE,
      ],
    }),

    // GET /teacher/groupLessons/{groupLessonId}/attendance/{enrollmentId}/history
    getTeacherAttendanceHistory: build.query<
      ITeacherAttendanceHistoryResponse,
      ITeacherAttendanceHistoryRequest
    >({
      query: ({ groupLessonId, enrollmentId }) =>
        `/teacher/groupLessons/${groupLessonId}/attendance/${enrollmentId}/history`,
      transformResponse: (response: SuccessApiResponse<ITeacherAttendanceHistoryResponse>) =>
        response.data,
      providesTags: [GET_TEACHER_ATTENDANCE_HISTORY],
    }),

    // GET /teacher/modules/{intakeModuleId}/group/{groupNumber}/attendance
    getTeacherModuleAttendance: build.query<
      ITeacherModuleAttendanceResponse,
      ITeacherModuleAttendanceRequest
    >({
      query: ({ intakeModuleId, groupNumber }) =>
        `/teacher/modules/${intakeModuleId}/group/${groupNumber}/attendance`,
      transformResponse: (response: SuccessApiResponse<ITeacherModuleAttendanceResponse>) =>
        response.data,
      providesTags: [GET_TEACHER_MODULE_ATTENDANCE],
    }),
  }),
});

export const {
  useGetTeacherAttendanceQuery,
  useCreateBulkAttendanceMutation,
  useUpdateAttendanceMutation,
  useGetTeacherAttendanceHistoryQuery,
  useGetTeacherModuleAttendanceQuery,
} = teacherAttendanceApi;
